import { userHasRight } from "../../../framework";
import { buildDataBindSyntax } from "../../components/buildDataBindSyntax";
import { ComponentOptions, RightLockable } from "../../components/components/component";
import { InputOptions } from "../../components/components/input";
import { TemplateComponent } from "../../components/components/templateComponent";
import K_Input from "../../components/templates/K_Input";
import { toolTip } from "../../controls/toolTip";
import { deepCloneEverything } from "../../core/core";
import { ll, LocalizedLanguage } from "../../core/ll";
import * as filter from "../../data/filter";
import { schemas } from "../../data/schemas";
import * as st from "../../data/searchTypes";
import { autoComplete } from "../autoComplete";
import { searchPopUp } from "../searchPopUp";
import K_TopToolbarSearch from "../templates/K_TopToolbarSearch";

export interface AutoCompleteOptions extends InputOptions, kendo.ui.AutoCompleteOptions {
    bindNumberValue?: string;
    useLink?: boolean | "true";
    linkedTo?: string;
    linkedToBind?: string;
    linkedClasses?: string;
    maxLength?: number | string;
    searchType?: string | any;
    templateName?: "K_Input" | "K_TopToolbarSearch";
    bindNumberField?: string;
    dataTextField?: string;
    bindId?: string;
    bindObject?: string;
    removeInvalidChars?: boolean;
    codeColumnsToIgnore?: string[];
    overrideUrl?: string;
    searchTypes?: any[];
    dataId?: string;
    dataObject?: string;
    entityTypeSchema?: string;
    searchOptions?: any[];
    filterExpression?: () => string;
    selectPath?: string;
    templateJSON?: any;
    clearIfInvalid?: boolean;
    autoCompleteConditional?: any[];
    extraTemplateColumns?: any[];
    zSelect?: any;
    beforeSend?: any;
    containsSearch?: boolean | "true";
    runOnEnterAndTab?: boolean;
    popUpTitle?: string;
    handlePopUpManually?: boolean;
    valueField?: string;
    companyGuid?: string;
    disableZSelect?: boolean;
    requiredRight?: string;
    urlPostfix?: string;
}

export class AutoComplete extends TemplateComponent {

    options: AutoCompleteOptions & RightLockable;
    originalFilters: any;
    filters: any;
    autoCompleteArgs: any;
    searchPopUpId: string;
    searchTypes: any;
    overrideUrl: string;
    searchPopUpArgs: any;
    overrideBeforeSend: any;

    /*
    * creates a AutoComplete component based on the Kendo AutoComplete control
    *
    *  These parameters are only used if the url parameter value is provided:
    *   filterType
    *   filterFields
    *   preFilter
    */
    constructor(options: AutoCompleteOptions) {
        options.templateName = options.templateName || "K_Input";
        const template = options.templateName == "K_TopToolbarSearch"
            ? K_TopToolbarSearch
            : K_Input;
        super(template, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || "no-pad";
            options.iconType = options.iconType || "list";
            options.iconId = options.iconId || `${options.id}Search`;
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 30;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.required = options.required || false;
        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        options.bindNumberField = options.bindNumberValue
            ? options.bindNumberValue.getAllAfterLastInstanceOf(".")
            : undefined;
        options.bindNumberValue = buildDataBindSyntax(options.bindNumberValue, "text");
        options.dataTextField = options.dataTextField;
        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.searchType = options.searchType;
        options.bindId = options.bindId || options.searchType + "Id";
        options.bindObject = options.bindObject || null;
        options.iconType = options.iconType || "";
        options.iconId = options.iconId || "";
        options.iconClasses = options.iconClasses || "";
        options.iconInput = options.iconType
            ? "icon-input"
            : "";
        options.maxLength = options.maxLength;
        options.useLink = options.useLink || null;
        options.linkedTo = options.linkedTo || null;
        options.linkedToBind = options.linkedToBind || null;
        options.removeInvalidChars = options.removeInvalidChars || false;
        options.codeColumnsToIgnore = options.codeColumnsToIgnore || [];

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.readonly = true;
                options.required = false;
                options.iconType = undefined;
                options.iconId = undefined;
                options.iconClasses = undefined;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }

        this.overrideUrl = options.overrideUrl;
    }

    /*
    * create
    * Wrapper for kendo template for AutoComplete Control
    *
    *
    * options.Id - Id for control
    * options.dataTextField - Display field for the control
    * options.dataValueField - Value field for the control
    * options.classes - Extra Classnames needed
    *
    */
    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }

        var me = this;
        const options = me.options;

        var searchTypes = options.searchTypes || [options.searchType];
        searchTypes = $.map(searchTypes, function (type) {
            var selectedAnElementFunc = function (data) {
                if (options.bindValue && typeof options.bindValue == "string") {
                    var bindData = $(`#${options.id}`).data("bindData");
                    var bindValue = options.bindValue.substr(options.bindValue.indexOf(":") + 2);
                    var value = data[bindValue.substring(bindValue.lastIndexOf(".") + 1)];

                    bindData.set(options.bindId, data[options.dataId] || data.Id);
                    if (options.bindObject) {
                        bindData.set(options.bindObject, data[options.dataObject] || data);
                    } else {
                        bindData.set(bindValue, value);
                    }
                }
            };

            var generatedSearchType = st.searchTypes.generate(type);
            generatedSearchType.selectedAnElement = selectedAnElementFunc;

            var displayFields = [];
            var schema = options.entityTypeSchema
                ? options.entityTypeSchema
                : schemas[generatedSearchType.entityType];

            if (schema) {
                var keys = Object.keys(schema.Properties);
                displayFields = $.grep(keys, function (c) { return schema.Properties[c].Display; });
            }

            if (options.searchOptions || generatedSearchType.searchOptions) {
                displayFields = options.searchOptions || generatedSearchType.searchOptions;
            }

            if (generatedSearchType.additionalDisplayFields) {
                displayFields = displayFields.concat(generatedSearchType.additionalDisplayFields);
            }

            generatedSearchType.displayFields = displayFields;
            generatedSearchType.searchOptions = displayFields;

            return generatedSearchType;
        });

        me.filters = me.originalFilters = $.map(searchTypes, function (type) {
            return type.filter || "";
        });

        var searchType = searchTypes[0];
        if (options.filterExpression) {
            searchType.filter = options.filterExpression();
        }

        me.autoCompleteArgs = {
            id: options.id,
            entityType: searchType.entityType,
            url: me.overrideUrl || searchType.url,
            bindNumberValue: options.bindNumberValue,
            bindNumberField: options.bindNumberField,
            dataTextField: options.dataTextField,
            fieldName: options.selectPath,
            disableZSelect: options.disableZSelect,
            filterExpression: searchType.filter,
            selectExpression: searchType.select,
            expandExpression: searchType.expand,
            sortExpression: searchType.sort,
            displayFields: searchType.displayFields,
            divisions: searchType.divisions,
            regions: searchType.regions,
            templateJSON: options.templateJSON,
            clearIfInvalid: options.clearIfInvalid,
            autoCompleteConditional: options.autoCompleteConditional,
            extraTemplateColumns: options.extraTemplateColumns,
            zSelect: function (data) {
                searchType.selectedAnElement(data);
                me.options.zSelect && me.options.zSelect.apply(this, [data, options]);
            },
            beforeSend: options.beforeSend,
            containsSearch: options.containsSearch,
            runOnEnterAndTab: options.runOnEnterAndTab,
            companyGuid: options.companyGuid
        };

        if (options.placeholder) {
            me.autoCompleteArgs.placeholder = ll(options.placeholder);
        }

        var searchPopUpTitle = options.popUpTitle || searchType.title || searchType.entityType;
        searchPopUpTitle = searchPopUpTitle.replaceAll("/", ".");
        if (LocalizedLanguage[`Entity.${searchPopUpTitle}`]) {
            searchPopUpTitle = `Entity.${searchPopUpTitle}`;
        }

        me.searchPopUpId = options.iconId ? `#${options.iconId}` : undefined;
        me.searchTypes = searchTypes;
        me.searchPopUpArgs = {
            id: `${searchType.entityType}SearchPopup`,
            title: ll(searchPopUpTitle),
            types: searchTypes,
            codeColumnsToIgnore: searchType.codeColumnsToIgnore,
            companyGuid: options.companyGuid
        };

        me.bindAutoCompleteAndSearchPopUp();
    }

    setAdditionalFilter(filterString) {
        var me = this;

        if (filterString) {
            me.filters = $.map(me.originalFilters, function (originalFilter) {
                return filter.where(originalFilter).and(filterString).toString();
            });
        } else {
            me.filters = me.originalFilters;
        }

        me.bindAutoCompleteAndSearchPopUp();
    }

    bindAutoCompleteAndSearchPopUp() {
        var me = this;

        me.autoCompleteArgs.filterExpression = me.filters[0];
        $.each(me.searchTypes, function (index, searchType) {
            searchType.filter = me.filters[index];
            if (me.overrideUrl) {
                searchType.url = me.overrideUrl;
            }
        });

        autoComplete(me.autoCompleteArgs);

        if (!me.options.handlePopUpManually && me.searchPopUpId) {
            $(me.searchPopUpId).off("click").tie("click", function () {
                var args = deepCloneEverything(me.searchPopUpArgs);
                if (me.overrideBeforeSend) {
                    args.beforeSend = me.overrideBeforeSend;
                }
                args.okClick = function () {
                    var searchWindow = popUp.window;
                    if (searchWindow.searchResults != null) {
                        var result = searchWindow.searchResults;
                        me.searchTypes[0].selectedAnElement(result);
                        me.options.zSelect && me.options.zSelect.apply(this, [result]);
                    }
                };
                var popUp = searchPopUp(args);
            });
        }
    }

    setUrl(url) {
        var me = this;

        ($(`#${me.id}`).data("kendoAutoComplete").dataSource as any).transport.options.read.url = url;
        me.overrideUrl = url;
        me.bindAutoCompleteAndSearchPopUp();
    }

    setBeforeSend(beforeSend) {
        var me = this;

        ($(`#${me.id}`).data("kendoAutoComplete").dataSource as any).transport.options.read.beforeSend = beforeSend;
        me.overrideBeforeSend = beforeSend;
    }

    setZSelect(zSelect) {
        var me = this;

        me.options.zSelect = zSelect;
    }

}
